import React, { useEffect, useState } from 'react';
import { get } from 'lodash';
import QSlider from './QSlider';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCommentAlt } from '@fortawesome/free-regular-svg-icons';
import { faCommentAlt as solidFaCommentAlt } from '@fortawesome/free-solid-svg-icons';
import { Button, makeStyles, Tooltip, useMediaQuery, useTheme } from '@material-ui/core';
import { useSnackbar } from 'notistack';
import { toggleStatement } from '../actions/answers';
import { useDispatch } from 'react-redux';

const useTooltipStyles = makeStyles({
  tooltip: {
    fontSize: 12,
  },
});

const SliderQuestion = ({
  remainingPoints,
  availablePoints,
  scaleRange,
  labels,
  statements,
  answers,
  comments,
  handleOpenComment,
  id,
  lang,
  eval: Eval,
  enabledSliderLabels,
}) => {
  const dispatch = useDispatch();
  const tooltipClasses = useTooltipStyles();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const theme = useTheme();
  const sm = useMediaQuery(theme.breakpoints.down('sm'));

  const [snackbarKey, setSnackbarKey] = useState('');

  useEffect(() => {
    closeSnackbar(snackbarKey);
  }, [remainingPoints]);

  const qSliderProps = {
    remainingPoints,
    answers,
    id,
    Eval,
    lang,
    scaleRange,
    labels,
  };

  return (
    <div className='statements'>
      {answers.map(({ statement_id, enabled, value }) => {
        const comment = comments.find(
          comment => comment.tsn_statement_id.toString() === statement_id.toString(),
        );

        const toggleStatementHandler = event => {
          const COST_OF_NOT_ANSWER = availablePoints / answers.length;
          if (remainingPoints + value < COST_OF_NOT_ANSWER && enabled) {
            const key = enqueueSnackbar(lang.q360_q_not_enough_points, {
              variant: 'error',
            });
            setSnackbarKey(key);
          } else {
            dispatch(
              toggleStatement(
                event.currentTarget.value,
                Eval.id,
                remainingPoints + value,
                availablePoints,
                answers,
              ),
            );
          }
        };

        return (
          <div className={`statement-sm ${enabled ? 'enabled-slider' : ''}`} key={statement_id}>
            <div className='text'>{statements[statement_id].text}</div>
            <div className='slider-with-val'>
              <div className={enabled ? 'slider-container' : 'slider-container-full'}>
                {enabled ? (
                  <QSlider
                    {...qSliderProps}
                    value={value}
                    enabledSliderLabels={enabledSliderLabels}
                    id={statement_id}
                  />
                ) : (
                  <span className='slider-disable'>
                    <span>{get(lang, 'q360_q_cannot_evaluate', 'q360_q_cannot_evaluate')}</span>
                  </span>
                )}
              </div>
              <div className='value-indicator'>
                {enabled && <span className='slider-value'>{parseFloat(value).toFixed(1)}</span>}
              </div>
            </div>
            <div className='statement-actions'>
              <div className='value-disable'>
                {sm ?
                  <button
                    onClick={toggleStatementHandler}
                    value={statement_id}
                  >
                    <div className={'fa fa-close slider-check-close'}/>
                    {enabled ? lang.q360_q_wont_evaluate : lang.q360_q_will_evaluate}
                  </button>
                  :
                  <Tooltip
                    placement='top'
                    title={enabled ? lang.q360_q_wont_evaluate : lang.q360_q_will_evaluate}
                    classes={tooltipClasses}
                    PopperProps={{ style: { fontSize: '11px !important' } }}
                  >
                    <button
                      className={'fa fa-close slider-check-close'}
                      onClick={toggleStatementHandler}
                      value={statement_id}
                    />
                  </Tooltip>
                }
              </div>
              <div className='value-comment'>
                {sm ?
                  <button
                    onClick={() => handleOpenComment({ statement_id, whom: Eval.id })}
                  >
                    <FontAwesomeIcon icon={comment.content ? solidFaCommentAlt : faCommentAlt} />
                    {lang.q360_comment_modal_label}
                  </button>
                  :
                  <button
                    className='comment-button'
                    onClick={() => handleOpenComment({ statement_id, whom: Eval.id })}
                  >
                    <FontAwesomeIcon icon={comment.content ? solidFaCommentAlt : faCommentAlt} />
                  </button>
                }
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default SliderQuestion;
